import script from "./FRemoveComment.vue?vue&type=script&setup=true&lang=ts"
export * from "./FRemoveComment.vue?vue&type=script&setup=true&lang=ts"

import "./FRemoveComment.vue?vue&type=style&index=0&id=0a1a8bcc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1a8bcc"]])

export default __exports__